import React from 'react';
import { FileSpreadsheetIcon, FileTextIcon, GiftIcon } from 'lucide-react';
import { bonos, BONOS_VALUE } from '../data/content';
import { Reveal } from './Reveal';
export function Bonuses() {
  return <section className="bg-sand py-20 sm:py-28" aria-labelledby="bonos-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-15" data-mp="avl8q8kv4hi1">
      <div className="mx-auto max-w-6xl px-6" data-id="element-16" data-mp="fsbrx4ryrt7o">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.8fr)] lg:items-end" data-id="element-17" data-mp="1tvlzg1xe6ql">
          <Reveal data-id="element-18" data-mp="5wi4gqcpifb4">
            <p className="inline-flex items-center gap-2 rounded-full bg-cream px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-cream-line" data-id="element-19" data-mp="5x1n69a6l7q7">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="3t0omehowa1u2" />
              Incluidos sin costo extra
            </p>
            <h2 id="bonos-title" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-21" data-mp="1m9qen74mz1g0">
              Más 5 bonos para cotizar, cobrar y organizarte
            </h2>
            <p className="mt-4 max-w-xl text-lg text-ink-soft" data-id="element-22" data-mp="3idmz7yg0j9gl">
              Las herramientas que usas en cada pedido: la calculadora de costos, el catálogo para tus clientes, la plantilla de cotización, los mensajes y los formatos de compras y producción.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-23" data-mp="3n4mwx5wyhvk5">
            <div className="rounded-2xl bg-cream p-7 ring-1 ring-inset ring-cream-line" data-id="element-24" data-mp="3n5oiw5fig2gn">
              <p className="text-sm font-semibold uppercase tracking-[0.16em] text-terra-dark" data-id="element-25" data-mp="2zgdco8fe5fv4">
                Formatos
              </p>
              <ul className="mt-4 space-y-3 text-[15px] text-ink-soft" data-id="element-26" data-mp="2uitzlbufj94r">
                <li className="flex items-start gap-3" data-id="element-27" data-mp="38hto8jhxzo0x">
                  <FileTextIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-700" aria-hidden="true" data-id="element-28" data-mp="33gnt6f0t7oo8" />
                  <span data-id="element-29" data-mp="npi1g5qfrkph">Bonos 1, 2, 4 y 5 en PDF, listos para ver o imprimir</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-30" data-mp="irq24qngowb9">
                  <FileSpreadsheetIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-700" aria-hidden="true" data-id="element-31" data-mp="itawaf5v6d8l" />
                  <span data-id="element-32" data-mp="3hhzlbf3gi5cc">Bono 3 en Excel: calcula costo, precio, anticipo y confirmación del pedido</span>
                </li>
              </ul>
            </div>
          </Reveal>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-33" data-mp="3lhrzc7bmd3p3">
          {bonos.map((bono, index) => <li key={bono.number} className="flex" data-id="element-34" data-mp="3qgbki5ie2bge" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col rounded-2xl border border-cream-line bg-cream/60 p-7" data-id="element-35" data-mp="2ttq4ysp0i9sl">
                <p className="flex items-center justify-between gap-3 text-xs font-semibold uppercase tracking-[0.16em] text-terra-dark" data-id="element-36" data-mp="2xrxileo6iuzk">
                  <span data-id="element-37" data-mp="37kd0kbzh7jkg">Bono {bono.number}</span>
                  <span className="rounded-full bg-sand px-2.5 py-1 tracking-[0.1em] text-mint-700 ring-1 ring-inset ring-cream-line" data-id="element-38" data-mp="37l4rvam1iv4x">
                    {bono.format}
                  </span>
                </p>
                <h3 className="mt-3 font-display text-xl leading-snug text-ink" data-id="element-39" data-mp="2f1645ypc4eeb">
                  {bono.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-40" data-mp="22keybejzzsy5">
                  {bono.description}
                </p>
                <p className="mt-auto flex items-baseline gap-2 pt-6" data-id="element-41" data-mp="1xk90thr1rc85">
                  <span className="text-sm text-ink-muted line-through" data-id="element-42" data-mp="1tl0547cg549y">
                    {bono.price}
                  </span>
                  <span className="text-sm font-semibold uppercase tracking-wide text-mint-700" data-id="element-43" data-mp="1omqd25m0qjsk">
                    Incluido
                  </span>
                </p>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.04} data-id="element-44" data-mp="1eszpd2xpuddx">
          <div className="mt-10 flex flex-col items-center justify-center gap-4 rounded-2xl bg-mint-700 px-8 py-7 text-center text-white" data-id="element-45" data-mp="19wrew2ugr8d3">
            <div data-id="element-46" data-mp="15u4kbu6er9c7">
              <p className="text-sm uppercase tracking-[0.16em] text-mint-100" data-id="element-47" data-mp="15wqnziq6h4p5">
                Valor total de los 5 bonos
              </p>
              <p className="mt-1 font-display text-3xl" data-id="element-48" data-mp="30xap9xdd55n6">
                <span className="line-through" data-id="element-49" data-mp="30zx50kaeqrgh">{BONOS_VALUE}</span>{' '}
                <span className="font-semibold text-mint-100" data-id="element-50" data-mp="34y4dysymqoh4">hoy incluidos</span>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}